/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const location_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M10 23h4m.25-15a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0ZM19 7.902c0 .958-.198 1.89-.594 2.783l-4.492 8.226A2.213 2.213 0 0 1 12 20c-.8 0-1.523-.421-1.92-1.1l-4.502-8.248A6.793 6.793 0 0 1 5 7.902C5 4.092 8.132 1 12 1s7 3.092 7 6.902Z"
    />
  </svg>
)
export default location_medium
